import {
    Avatar,
    AvatarFallback,
    AvatarImage,
    Button,
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    Separator,
} from '@repo/shadcn';
import { PlusCircle } from 'lucide-react';
import { BiLogOut } from 'react-icons/bi';
import { FcAcceptDatabase, FcSettings } from 'react-icons/fc';
import { Link } from 'react-router-dom';

import { Route } from '@/constants';
import { useAppSelector } from '@/features';
import { useAuth } from '@/hooks';
import { RecentNotification } from '@/modules/notification/recent-notifications';

export const HeaderEnd = () => {
    const { email, role, name } = useAppSelector((state) => state.auth.user);
    const { signOut, isSigningOut } = useAuth();

    return (
        <div className="flex items-center gap-4">
            <div className={'flex items-center justify-end'}>
                <Link to={Route.POS_NEW}>
                    <Button
                        variant="ghost"
                        className="flex items-center gap-2"
                        size={'sm'}
                    >
                        <PlusCircle /> New Sale
                    </Button>
                </Link>

                <RecentNotification />
            </div>
            <Avatar>
                <Select
                    disabled={isSigningOut}
                    onValueChange={(value) => {
                        if (value === 'logout') {
                            void signOut();
                        }
                    }}
                >
                    <SelectTrigger aria-label="User menu" className="p-0">
                        <AvatarImage src="/icons/user.svg" alt="@shadcn" />
                        <AvatarFallback>CN</AvatarFallback>
                    </SelectTrigger>
                    <SelectContent className="w-[200px]">
                        <div className="px-4 py-3">
                            <p className="font-semibold">{email}</p>
                            <p className="text-[14px]">{name}</p>
                            <p className="text-[14px]">{role?.name}</p>
                        </div>
                        <Separator className="mb-2" />
                        <SelectItem value="light">
                            <Button
                                variant="ghost"
                                type="button"
                                className="flex items-center gap-2"
                            >
                                <FcAcceptDatabase className="text-[18px]" />{' '}
                                Permissions
                            </Button>
                        </SelectItem>
                        <SelectItem value="dark">
                            <Button
                                variant="ghost"
                                type="button"
                                className="flex items-center gap-2"
                            >
                                <FcSettings className="text-[18px]" /> Settings
                            </Button>
                        </SelectItem>
                        <SelectItem value="logout">
                            <Button
                                variant="ghost"
                                type="button"
                                className="flex items-center gap-2"
                            >
                                <BiLogOut className="text-[18px]" /> Log Out
                            </Button>
                        </SelectItem>
                    </SelectContent>
                </Select>
            </Avatar>
        </div>
    );
};
